module.exports = __webpack_public_path__ + "static/media/insurance_item-07.2da0eba7.svg";